import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
;
import { BoardCount, BoardTable, BoardSunburst } from "../../index";
function Visualisation(props) {
    const { componentType } = props;
    switch (componentType) {
        case "table":
            return _jsx(BoardTable, { ...props });
        case "count":
            return _jsx(BoardCount, { ...props });
        case "sunburst":
            return _jsx(BoardSunburst, { ...props });
    }
}
export default Visualisation;
